export default __webpack_public_path__ + "static/media/42.2459cf1a.jpeg";